<template>
  <b-modal
    id="audio-record-error-modal"
    ref="audioRecordErrorModal"
    :title="title"
    modal-class="audio-record-error-modal"
    hide-footer>
    <p style="font-size: 14px">
      {{ description }}
    </p>
    <b-button
      class="btn-round btn-block mt-5 mb-3"
      @click="hide">
      Ok, Got it
    </b-button>
  </b-modal>
</template>

<script>
export default {
  name: 'AudioRecordErrorModal',
  data() {
    return {
      errorType: 'somethingWrong',
    };
  },
  computed: {
    title() {
      switch (this.errorType) {
        case 'NotAllowedError': {
          return 'Allow microphone access';
        }
        case 'NotFoundError': {
          return 'Microphone Not Found';
        }
        default: {
          return 'Microphone error';
        }
      }
    },
    description() {
      switch (this.errorType) {
        case 'NotAllowedError': {
          return 'To record Voice Messages, AI Number needs access to your microphone. ' +
              'Please allow AI Number to use your microphone from your browser settings.';
        }
        case 'NotFoundError': {
          return 'You can\'t record a Voice Message because it looks like your computer doesn\'t have a microphone.' +
              ' Try connecting one or if you have one connected, try restarting your browser.';
        }
        default: {
          return 'There is something wrong with your microphone.';
        }
      }
    },
  },
  methods: {
    show(errorType) {
      this.errorType = errorType;
      this.$refs.audioRecordErrorModal.show();
    },
    hide() {
      this.$refs.audioRecordErrorModal.hide();
    },
  },
};
</script>
